import React, { useEffect } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "./Dashboard.css";
import "../styles/main.css";
import "../styles/Timeline.css";

import { Alert, Badge, Form, Spinner } from "react-bootstrap";
const tasks = [
  {
    title: "Task Created by Anup TC",
    startDate: "2025-06-01",
    endDate: "2025-06-05",
    deadline: "2025-06-07",
    completed: true,
  },
  {
    title: "Task 2",
    startDate: "2025-06-06",
    endDate: "2025-06-09",
    deadline: "2025-06-10",
    completed: false,
  },
  {
    title: "Test Payment Gateway",
    startDate: "2025-06-11",
    endDate: "2025-06-13",
    deadline: "2025-06-14",
    completed: false,
  },
];

const Timeline = () => {
  useEffect(() => {
    const items = document.querySelectorAll('.timeline-item');

    const onScroll = () => {
      items.forEach((item) => {
        const rect = item.getBoundingClientRect();
        if (rect.top < window.innerHeight - 100) {
          item.classList.add('show');
        }
      });
    };

    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="container py-5">
      <h3 className="text-center mb-4">📌 Project Task Timeline</h3>
      <div className="timeline">
        {tasks.map((task, idx) => (
          <div className="timeline-item" key={idx}>
            <div className="timeline-dot"></div>
            <div className="timeline-content card">
              <div className="card-body">
                <h5 className="card-title">{task.title}</h5>
                <p className="mb-1"><strong>Start:</strong> {task.startDate}</p>
                <p className="mb-1"><strong>End:</strong> {task.endDate}</p>
                <p className="mb-1"><strong>Deadline:</strong> {task.deadline}</p>
                <p className="mb-0">
                  <strong>Status:</strong>{" "}
                  <span className={task.completed ? 'text-success' : 'text-danger'}>
                    {task.completed ? "Completed ✅" : "Pending ⏳"}
                  </span>
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Timeline;